<template>
  <div>
    <header id="masthead" class="registration deleteAccount">
      <div class="wp800">
        <router-link :to="{ name: 'home' }">
          <a class="logo"></a>
        </router-link>
      </div>
    </header>
    <section>
      <!-- delete account step 3 -->
      <div class="deleteProfile step3 popUp wp800">
        <div class="content">
          <h2>{{ $t("delete_profile.success_title") }}</h2>
          <p v-html="$t('delete_profile.success_text')"></p>

          <router-link to="/" class="txt">{{ $t("delete_profile.success_link") }}</router-link>
        </div>
      </div>
    </section>
  </div>

</template>
<script>
export default {
  data() {
    return{
      classHeader:"registration",
      classGrid:"wp1200"
    }
  },
};
</script>